import { size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { SelectableBox } from "../../SelectableBox";
import { OptionContainer } from "./OptionContainer";
export const Option = styled(SelectableBox) `
  transform: none;

  ${OptionContainer}:not(.withGap) & {
    border-radius: 0;
  }

  ${OptionContainer}:not(.compact) & {
    &:first-child {
      border-top-left-radius: ${size.borderRadius};
      border-bottom-left-radius: ${size.borderRadius};
    }

    &:last-child {
      border-top-right-radius: ${size.borderRadius};
      border-bottom-right-radius: ${size.borderRadius};
    }
  }

  ${OptionContainer}.compact & {
    &:first-child {
      border-top-left-radius: ${size.borderRadius};
      border-top-right-radius: ${size.borderRadius};
    }

    &:last-child {
      border-bottom-left-radius: ${size.borderRadius};
      border-bottom-right-radius: ${size.borderRadius};
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3B0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2VsZWN0Qm94L3N0eWxlZC9PcHRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQ3RFLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxxQkFBcUIsQ0FBQztBQUNwRCxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFFcEQsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxhQUFhLENBQUMsQ0FBQTs7O0lBR3ZDLGVBQWU7Ozs7SUFJZixlQUFlOztnQ0FFYSxJQUFJLENBQUMsWUFBWTttQ0FDZCxJQUFJLENBQUMsWUFBWTs7OztpQ0FJbkIsSUFBSSxDQUFDLFlBQVk7b0NBQ2QsSUFBSSxDQUFDLFlBQVk7Ozs7SUFJakQsZUFBZTs7Z0NBRWEsSUFBSSxDQUFDLFlBQVk7aUNBQ2hCLElBQUksQ0FBQyxZQUFZOzs7O21DQUlmLElBQUksQ0FBQyxZQUFZO29DQUNoQixJQUFJLENBQUMsWUFBWTs7O0NBR3BELENBQUMifQ==